import React, { useEffect, useState } from "react";

import { postKritikSaran } from "../../api";

import Select from "react-select";
import { fetchPegawai } from "../../api";



const KritikSaranForm = ({
  onSuccess = () => {},
  defaultKategori = "",
}) => {
  /*
  |--------------------------------------------------------------------------
  | STATE
  |--------------------------------------------------------------------------
  */
  const [pegawaiOptions, setPegawaiOptions] = useState([]);

  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    kategori: "",

    tujuan_type: "",

    tujuan_id: "",

    tujuan_manual: "",

    judul: "",

    isi: "",

    lampiran: null,

    is_anonim: false,
  });

  /*
  |--------------------------------------------------------------------------
  | HANDLE CHANGE
  |--------------------------------------------------------------------------
  */

  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;

  //   setForm((prev) => ({
  //     ...prev,
  //     [name]:
  //       type === "checkbox"
  //         ? checked
  //         : value,
  //   }));
  // };

  const handleChange = (e) => {
    const {
      name,
      value,
      type,
      checked,
    } = e.target;

    setForm((prev) => {

      let newForm = {
        ...prev,

        [name]:
          type === "checkbox"
            ? checked
            : value,
      };

      // reset jika ganti tujuan_type
      if (name === "tujuan_type") {
        newForm.tujuan_id = "";
        newForm.tujuan_manual = "";
      }

      return newForm;
    });
  };

  /*
  |--------------------------------------------------------------------------
  | HANDLE FILE
  |--------------------------------------------------------------------------
  */

  const handleFile = (e) => {
    setForm((prev) => ({
      ...prev,
      lampiran: e.target.files[0],
    }));
  };

  /*
  |--------------------------------------------------------------------------
  | RESET TUJUAN
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    setForm((prev) => ({
      ...prev,
      tujuan_id: "",
      tujuan_manual: "",
    }));
  }, [form.tujuan_type]);


  useEffect(() => {
    let isMounted = true;

    const getPegawai = async () => {
      try {
        const res = await fetchPegawai("all");

        const raw = res.data?.pegawai || [];

        const options = raw.map((p) => ({
          value: p.id,
          label: `${p.nama} - ${p.nip}`,
        }));

        if (isMounted) {
          setPegawaiOptions(options);
        }
      } catch (err) {
        console.error(err);
      }
    };

    getPegawai();

    return () => {
      isMounted = false;
    };
  }, []);

  /*
  |--------------------------------------------------------------------------
  | SUBMIT
  |--------------------------------------------------------------------------
  */

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const formData = new FormData();

    //   Object.keys(form).forEach((key) => {
    //     if (
    //       form[key] !== null &&
    //       form[key] !== undefined
    //     ) {
    //       formData.append(key, form[key]);
    //     }
    //   });

    formData.append(
    "kategori",
    form.kategori
    );

    formData.append(
    "tujuan_type",
    form.tujuan_type
    );

    formData.append(
    "tujuan_id",
    form.tujuan_id || ""
    );

    formData.append(
    "tujuan_manual",
    form.tujuan_manual || ""
    );

    formData.append(
    "judul",
    form.judul
    );

    formData.append(
    "isi",
    form.isi
    );

    formData.append(
    "is_anonim",
    form.is_anonim ? 1 : 0
    );

    if (form.tujuan_type === "group" && !form.tujuan_manual) {
      alert("Pilih group terlebih dahulu");
      return;
    }

    if (form.lampiran) {
        formData.append(
            "lampiran",
            form.lampiran
        );
    }

      const res = await postKritikSaran(formData);

      if (res.data) {
        alert("Kritik & Saran berhasil dikirim");

        /*
        |--------------------------------------------------------------------------
        | RESET FORM
        |--------------------------------------------------------------------------
        */

        setForm({
          kategori: "",

          tujuan_type: "",

          tujuan_id: "",

          tujuan_manual: "",

          judul: "",

          isi: "",

          lampiran: null,

          is_anonim: false,
        });

        onSuccess(res.data);
      }
    } catch (err) {
      console.error(err);

      alert(
        err?.response?.data?.message ||
          "Terjadi kesalahan"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="card border-0 shadow-sm">
          <div className="card-body">
            <div className="row">
              {/* KATEGORI */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Kategori
                </label>

                <select
                  name="kategori"
                  className="form-select"
                  value={form.kategori}
                  onChange={handleChange}
                  required
                >

                  <option value="">
                        -- Pilih Kategori --
                    </option>

                  <option value="kritik">
                    Kritik
                  </option>

                  <option value="saran">
                    Saran
                  </option>
                </select>
              </div>

              {/* TUJUAN TYPE */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Tujuan
                </label>

                <select
                  name="tujuan_type"
                  className="form-select"
                  value={form.tujuan_type}
                  onChange={handleChange}
                  required
                >
                    <option value="">
                        -- Pilih Tujuan --
                    </option>

                  <option value="pegawai">
                    Pegawai
                  </option>

                  <option value="group">
                    Group
                  </option>

                  <option value="umum">
                    Umum
                  </option>
                </select>
              </div>

              {/* TUJUAN PEGAWAI */}
              {["pegawai", "dosen"].includes(
                form.tujuan_type
              ) && (
                <div className="col-md-12 mb-3">
                  <label className="form-label">
                    Pegawai Tujuan
                  </label>

                  {/* <input
                    type="number"
                    name="tujuan_id"
                    className="form-control"
                    placeholder="Masukkan ID tujuan"
                    value={form.tujuan_id}
                    onChange={handleChange}
                    required
                  /> */}
                  {form.tujuan_type === "pegawai" && (
                    <div className="col-md-12 mb-3">
                      {/* <label className="form-label">
                        Pilih Pegawai
                      </label> */}

                      <Select
                        options={pegawaiOptions}
                        value={pegawaiOptions.find(
                          (opt) => opt.value === form.tujuan_id
                        )}
                        onChange={(selected) =>
                          setForm((prev) => ({
                            ...prev,
                            tujuan_id: selected
                              ? selected.value
                              : "",
                          }))
                        }
                        placeholder="Cari nama pegawai..."
                        isClearable
                      />
                    </div>
                  )}

                </div>
              )}

              {/* TUJUAN GROUP */}
              {form.tujuan_type === "group" && (
                <div className="col-md-12 mb-3">
                  <label className="form-label">
                    Pilih Group
                  </label>

                  <select
                    name="tujuan_manual"
                    className="form-select"
                    value={form.tujuan_manual}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Pilih</option>
                    <option value="Dir">Dir</option>
                    <option value="Kacab">Kacab</option>
                    <option value="Akademik">Akademik</option>
                    <option value="SDM">SDM</option>
                    <option value="Marketing">Marketing</option>
                    <option value="PM">PM</option>
                    <option value="PKK">PKK</option>
                    <option value="Magang">Magang</option>
                  </select>
                </div>
              )}

              {/* TUJUAN MANUAL */}
              {["umum"].includes(
                form.tujuan_type
              ) && (
                <div className="col-md-12 mb-3">
                  <label className="form-label">
                    Tujuan
                  </label>

                  <input
                    type="text"
                    name="tujuan_manual"
                    className="form-control"
                    placeholder="Contoh : Kebersiahan, Keamanan, dll"
                    value={form.tujuan_manual}
                    onChange={handleChange}
                    required
                  />
                </div>
              )}

              {/* JUDUL */}
              <div className="col-md-12 mb-3">
                <label className="form-label">
                  Judul
                </label>

                <input
                  type="text"
                  name="judul"
                  className="form-control"
                  placeholder="Masukkan judul kritik atau saran"
                  value={form.judul}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* ISI */}
              <div className="col-md-12 mb-3">
                <label className="form-label">
                  Isi Kritik / Saran
                </label>

                <textarea
                  name="isi"
                  className="form-control"
                  rows="6"
                  placeholder="Tuliskan kritik atau saran"
                  value={form.isi}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* LAMPIRAN */}
              <div className="col-md-12 mb-3">
                <label className="form-label">
                  Lampiran
                </label>

                <input
                  type="file"
                  className="form-control"
                  onChange={handleFile}
                  accept=".jpg,.jpeg,.png,.pdf"
                />

                <small className="text-muted">
                  Format : JPG, PNG, PDF
                </small>
              </div>

              {/* ANONIM */}
              <div className="col-md-12 mb-3">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="is_anonim"
                    name="is_anonim"
                    checked={form.is_anonim}
                    onChange={handleChange}
                  />

                  <label
                    className="form-check-label"
                    htmlFor="is_anonim"
                  >
                    Kirim sebagai anonim
                  </label>
                </div>
              </div>

              {/* BUTTON */}
              <div className="col-md-12">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <i className="fa fa-fw fa-spinner fa-spin me-1" />
                      Mengirim...
                    </>
                  ) : (
                    <>
                      <i className="fa fa-fw fa-paper-plane me-1" />
                      Kirim Kritik & Saran
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default KritikSaranForm;